import React, { useEffect, useState } from 'react';
import Navbar from "./Navbar";
import Footer from "./Footer.jsx";
import broucher_1 from "./IMGS/FIESTABROUCHER_1.jpg";
import broucher_2 from "./IMGS/FIESTABROUCHER.jpg";
import Testimonial from "./IMGS/Testimonial.png";
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';

// API Base URL
//const API_BASE_URL = 'http://localhost/royaleheritagefiesta/api';
const API_BASE_URL = 'https://royaleheritagefiesta.com/royaleheritagefiesta/api';

const Home = () => {
  const navigate = useNavigate();
  const [timeLeft, setTimeLeft] = useState({ days: '00', hours: '00', minutes: '00', seconds: '00' });
  const [showBackToTop, setShowBackToTop] = useState(false);
  const [showFloatingButtons, setShowFloatingButtons] = useState(false);
  const [upcomingEvents, setUpcomingEvents] = useState([]);
  const [featuredEvent, setFeaturedEvent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [apiError, setApiError] = useState(null);
  const [showFloatingImage, setShowFloatingImage] = useState(true);
  const [currentFloatingSlide, setCurrentFloatingSlide] = useState(0);
  
  const [floatingImages, setFloatingImages] = useState([
    { src: broucher_1, alt: "Special Offer 1" },
    { src: broucher_2, alt: "Special Offer 2" }
  ]);
  
  // CMS Content State
  const [cmsContent, setCmsContent] = useState({
    featuredEvent: { badge: 'FEATURED EVENT', button1: 'Book a Stall', button2: 'Get Tickets' },
    upcomingEvents: { title: 'Featured Events', subtitle: '✦ UPCOMING EVENTS', viewAllText: 'View all' },
    services: {
      title: 'Our Signature Experiences',
      subtitle: 'Discover the essence of royal celebrations',
      service1_title: 'Royal Heritage Fiesta',
      service1_desc: 'Curated heritage experiences celebrating tradition and grandeur.',
      service1_link: '/RoyalHeritageFiesta',
      service2_title: 'Royal Dinners',
      service2_desc: 'Exquisite fine dining experiences with royal ambiance.',
      service2_link: '/RoyalDinners',
      service3_title: 'Music & Concerts',
      service3_desc: 'World-class performances and unforgettable experiences.',
      service3_link: '/MusicAndConcerts'
    },
    booking: {
      title: 'Plan Your Royal Experience',
      subtitle: 'Share your details and we\'ll get back to you via WhatsApp',
      whatsapp_number: '919966252374',
      button_text: 'Send via WhatsApp'
    },
    about: {
      title: 'About Royal Heritage Fiesta',
      description: 'Royal Heritage Fiesta is dedicated to creating unforgettable experiences...'
    },
    testimonials: {
      title: 'What Our Guests Say',
      subtitle: 'Experiences that speak for themselves',
      testimonial1_name: 'Vikram Singh',
      testimonial1_title: 'Event Attendee',
      testimonial1_text: 'The Royal Heritage Fiesta was absolutely magnificent!',
      testimonial2_name: 'Meera Kapoor',
      testimonial2_title: 'Dinner Guest',
      testimonial2_text: 'The Royal Dinners experience was beyond imagination.',
      testimonial3_name: 'Arjun Nair',
      testimonial3_title: 'Music Lover',
      testimonial3_text: 'The concert was spectacular!'
    },
    location: {
      title: 'Our Venues',
      subtitle: 'Experience royalty at our premier locations',
      hq_name: 'Hyderabad (HQ)',
      hq_address: 'VIP Hills, Silicon Valley, Madhapur',
      hq_city: 'Hyderabad - 500081, Telangana',
      hq_phone: '+91 99662 52374',
      hq_email: 'royaleheritagefiesta@gmail.com',
      map_embed: 'https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d7612.584996745508!2d78.38633559192071!3d17.445708893577407!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v1774850334297!5m2!1sen!2sin'
    },
    cta: {
      title: 'Ready To Experience Royalty?',
      subtitle: 'Book your seat at our next grand celebration',
      button1_text: 'Talk to us',
      button2_text: 'Call +91 99662 52374',
      phone1: '+919396536350',
      phone2: '+919966252374'
    }
  });
  
  const [cmsImages, setCmsImages] = useState({});
  const [contentLoading, setContentLoading] = useState(true);
  
  // Default carousel images and text
  const [carouselImages, setCarouselImages] = useState([
    {
      url: "https://images.unsplash.com/photo-1711867623677-d34515fe679b?w=600",
      title: "Royal Heritage Fiesta",
      description: "Where Legacy Meets Celebration",
      link: "/RoyalHeritageFiesta"
    },
    {
      url: "https://images.unsplash.com/photo-1536392706976-e486e2ba97af?q=80&w=800",
      title: "Royal Dinners",
      description: "Indulge in exquisite culinary masterpieces",
      link: "/RoyalDinners"
    },
    {
      url: "https://images.pexels.com/photos/167491/pexels-photo-167491.jpeg",
      title: "Music & Concerts",
      description: "World-class performances",
      link: "/MusicAndConcerts"
    }
  ]);

  // Fetch CMS content
  useEffect(() => {
    const fetchCMSContent = async () => {
      try {
        setContentLoading(true);
        const response = await axios.get(`${API_BASE_URL}/get-home-content.php`);
        console.log('CMS Response:', response.data);
        
        if (response.data.success) {
          const cmsData = response.data.data;
          const cmsImagesData = response.data.images || {};
          
          // Update Featured Event
          if (cmsData.featuredEvent) {
            setCmsContent(prev => ({
              ...prev,
              featuredEvent: {
                badge: cmsData.featuredEvent.badge || prev.featuredEvent.badge,
                button1: cmsData.featuredEvent.button1 || prev.featuredEvent.button1,
                button2: cmsData.featuredEvent.button2 || prev.featuredEvent.button2
              }
            }));
          }
          
          // Update Upcoming Events
          if (cmsData.upcomingEvents) {
            setCmsContent(prev => ({
              ...prev,
              upcomingEvents: {
                title: cmsData.upcomingEvents.title || prev.upcomingEvents.title,
                subtitle: cmsData.upcomingEvents.subtitle || prev.upcomingEvents.subtitle,
                viewAllText: cmsData.upcomingEvents.viewAllText || prev.upcomingEvents.viewAllText
              }
            }));
          }
          
          // Update Services
          if (cmsData.services) {
            setCmsContent(prev => ({
              ...prev,
              services: {
                title: cmsData.services.title || prev.services.title,
                subtitle: cmsData.services.subtitle || prev.services.subtitle,
                service1_title: cmsData.services.service1_title || prev.services.service1_title,
                service1_desc: cmsData.services.service1_desc || prev.services.service1_desc,
                service1_link: cmsData.services.service1_link || prev.services.service1_link,
                service2_title: cmsData.services.service2_title || prev.services.service2_title,
                service2_desc: cmsData.services.service2_desc || prev.services.service2_desc,
                service2_link: cmsData.services.service2_link || prev.services.service2_link,
                service3_title: cmsData.services.service3_title || prev.services.service3_title,
                service3_desc: cmsData.services.service3_desc || prev.services.service3_desc,
                service3_link: cmsData.services.service3_link || prev.services.service3_link
              }
            }));
          }
          
          // Update Booking
          if (cmsData.booking) {
            setCmsContent(prev => ({
              ...prev,
              booking: {
                title: cmsData.booking.title || prev.booking.title,
                subtitle: cmsData.booking.subtitle || prev.booking.subtitle,
                whatsapp_number: cmsData.booking.whatsapp_number || prev.booking.whatsapp_number,
                button_text: cmsData.booking.button_text || prev.booking.button_text
              }
            }));
          }
          
          // Update About
          if (cmsData.about) {
            setCmsContent(prev => ({
              ...prev,
              about: {
                title: cmsData.about.title || prev.about.title,
                description: cmsData.about.description || prev.about.description
              }
            }));
          }
          
          // Update Testimonials
          if (cmsData.testimonials) {
            setCmsContent(prev => ({
              ...prev,
              testimonials: {
                title: cmsData.testimonials.title || prev.testimonials.title,
                subtitle: cmsData.testimonials.subtitle || prev.testimonials.subtitle,
                testimonial1_name: cmsData.testimonials.testimonial1_name || prev.testimonials.testimonial1_name,
                testimonial1_title: cmsData.testimonials.testimonial1_title || prev.testimonials.testimonial1_title,
                testimonial1_text: cmsData.testimonials.testimonial1_text || prev.testimonials.testimonial1_text,
                testimonial2_name: cmsData.testimonials.testimonial2_name || prev.testimonials.testimonial2_name,
                testimonial2_title: cmsData.testimonials.testimonial2_title || prev.testimonials.testimonial2_title,
                testimonial2_text: cmsData.testimonials.testimonial2_text || prev.testimonials.testimonial2_text,
                testimonial3_name: cmsData.testimonials.testimonial3_name || prev.testimonials.testimonial3_name,
                testimonial3_title: cmsData.testimonials.testimonial3_title || prev.testimonials.testimonial3_title,
                testimonial3_text: cmsData.testimonials.testimonial3_text || prev.testimonials.testimonial3_text
              }
            }));
          }
          
          // Update Location
          if (cmsData.location) {
            setCmsContent(prev => ({
              ...prev,
              location: {
                title: cmsData.location.title || prev.location.title,
                subtitle: cmsData.location.subtitle || prev.location.subtitle,
                hq_name: cmsData.location.hq_name || prev.location.hq_name,
                hq_address: cmsData.location.hq_address || prev.location.hq_address,
                hq_city: cmsData.location.hq_city || prev.location.hq_city,
                hq_phone: cmsData.location.hq_phone || prev.location.hq_phone,
                hq_email: cmsData.location.hq_email || prev.location.hq_email,
                map_embed: cmsData.location.map_embed || prev.location.map_embed
              }
            }));
          }
          
          // Update CTA
          if (cmsData.cta) {
            setCmsContent(prev => ({
              ...prev,
              cta: {
                title: cmsData.cta.title || prev.cta.title,
                subtitle: cmsData.cta.subtitle || prev.cta.subtitle,
                button1_text: cmsData.cta.button1_text || prev.cta.button1_text,
                button2_text: cmsData.cta.button2_text || prev.cta.button2_text,
                phone1: cmsData.cta.phone1 || prev.cta.phone1,
                phone2: cmsData.cta.phone2 || prev.cta.phone2
              }
            }));
          }
          
          // Handle carousel images AND TEXT from carouselData
          setCmsImages(cmsImagesData);
          
          // Update carousel - images from cmsImagesData, text from cmsData.carousel
          const carouselData = cmsData.carousel || {};
          
          // Update carousel images and text
          const updatedCarousel = [...carouselImages];
          
          // Slide 1
          if (cmsImagesData.carousel_1) updatedCarousel[0].url = cmsImagesData.carousel_1;
          if (carouselData.slide1_title) updatedCarousel[0].title = carouselData.slide1_title;
          if (carouselData.slide1_desc) updatedCarousel[0].description = carouselData.slide1_desc;
          if (carouselData.slide1_link) updatedCarousel[0].link = carouselData.slide1_link;
          
          // Slide 2
          if (cmsImagesData.carousel_2) updatedCarousel[1].url = cmsImagesData.carousel_2;
          if (carouselData.slide2_title) updatedCarousel[1].title = carouselData.slide2_title;
          if (carouselData.slide2_desc) updatedCarousel[1].description = carouselData.slide2_desc;
          if (carouselData.slide2_link) updatedCarousel[1].link = carouselData.slide2_link;
          
          // Slide 3
          if (cmsImagesData.carousel_3) updatedCarousel[2].url = cmsImagesData.carousel_3;
          if (carouselData.slide3_title) updatedCarousel[2].title = carouselData.slide3_title;
          if (carouselData.slide3_desc) updatedCarousel[2].description = carouselData.slide3_desc;
          if (carouselData.slide3_link) updatedCarousel[2].link = carouselData.slide3_link;
          
          setCarouselImages(updatedCarousel);
          
          // Update floating images
          if (cmsImagesData.floating_image_1) {
            setFloatingImages(prev => {
              const newImages = [...prev];
              if (newImages[0]) newImages[0].src = cmsImagesData.floating_image_1;
              return newImages;
            });
          }
          if (cmsImagesData.floating_image_2) {
            setFloatingImages(prev => {
              const newImages = [...prev];
              if (newImages[1]) newImages[1].src = cmsImagesData.floating_image_2;
              return newImages;
            });
          }
        }
      } catch (error) {
        console.error('Error fetching CMS:', error);
      } finally {
        setContentLoading(false);
      }
    };
    
    fetchCMSContent();
  }, []);

  // Auto-rotate floating images
  useEffect(() => {
    if (!showFloatingImage || floatingImages.length === 0) return;
    const interval = setInterval(() => {
      setCurrentFloatingSlide((prev) => (prev + 1) % floatingImages.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [showFloatingImage, floatingImages.length]);

  // Form states
  const [formLoading, setFormLoading] = useState(false);
  const [formSuccess, setFormSuccess] = useState('');
  const [formError, setFormError] = useState('');
  const [featuredEventTimeLeft, setFeaturedEventTimeLeft] = useState({ days: '00', hours: '00', minutes: '00', seconds: '00' });
  const [currentSlide, setCurrentSlide] = useState(0);

  // Event date for countdown
  const eventDate = new Date(2026, 2, 15, 9, 0, 0).getTime();

  // Auto slide for carousel
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % carouselImages.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [carouselImages.length]);

  const handleCarouselClick = (link) => {
    if (link) navigate(link);
  };

  const getEventImage = (eventName, eventType) => {
    const name = eventName?.toLowerCase() || '';
    const type = eventType?.toLowerCase() || '';
    
    if (name.includes('royal heritage') || type.includes('heritage')) {
      return 'https://lh3.googleusercontent.com/b_cbWUjOMRlQ4WdZekGaHpXjyE8xKAVYsbOyi143Ln35w07jOPhFNjRNF2zcX8olrMGJe4RxxSld6DyVz41fRuuINw=w1500-h1000-l95-e31';
    }
    if (name.includes('royal dinner') || type.includes('dinner')) {
      return 'https://images.unsplash.com/photo-1576326062417-11b7c40e8ddf?w=600';
    }
    if (name.includes('music') || type.includes('concert')) {
      return 'https://images.pexels.com/photos/167491/pexels-photo-167491.jpeg';
    }
    return 'https://www.chowmahalla.in/wp-content/uploads/2021/10/Beyond-The-Marvelous-Khilwat-khilwat-mubarak.jpg';
  };

  // Fetch events from PHP API
  useEffect(() => {
    const fetchEvents = async () => {
      try {
        setLoading(true);
        setApiError(null);
        
        const response = await axios.get(`${API_BASE_URL}/events.php?all`);
        
        let cleanData = response.data;
        
        if (typeof cleanData === 'string') {
          cleanData = cleanData.replace(/<br\s*\/?>/gi, '');
          cleanData = cleanData.replace(/<b>Warning<\/b>:[^<]*/gi, '');
          cleanData = cleanData.replace(/<b>.*?<\/b>/g, '');
          cleanData = cleanData.replace(/^\s*[\r\n]/gm, '');
          cleanData = cleanData.trim();
          
          const jsonMatch = cleanData.match(/\[[\s\S]*\]/);
          if (jsonMatch) {
            cleanData = jsonMatch[0];
          }
          
          try {
            cleanData = JSON.parse(cleanData);
          } catch (e) {
            cleanData = [];
          }
        }
        
        let eventsArray = [];
        if (Array.isArray(cleanData)) {
          eventsArray = cleanData;
        } else if (cleanData.data && Array.isArray(cleanData.data)) {
          eventsArray = cleanData.data;
        } else {
          eventsArray = [];
        }
        
        if (eventsArray.length > 0) {
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          
          const futureEvents = eventsArray.filter(event => {
            if (!event.eventDate) return false;
            const eventDate = new Date(event.eventDate);
            eventDate.setHours(0, 0, 0, 0);
            return eventDate >= today;
          });
          
          const sortedEvents = [...futureEvents].sort((a, b) => 
            new Date(a.eventDate) - new Date(b.eventDate)
          );
          
          const upcoming = sortedEvents.slice(0, 4);
          
          const upcomingWithImages = upcoming.map(event => ({
            ...event,
            img: getEventImage(event.eventName, event.eventType)
          }));
          
          setUpcomingEvents(upcomingWithImages);
          
          if (upcomingWithImages.length > 0) {
            setFeaturedEvent(upcomingWithImages[0]);
          }
        } else {
          setApiError("No events found");
        }
        
        setLoading(false);
      } catch (error) {
        console.error("Error fetching events:", error);
        setApiError("Could not load events from server.");
        setLoading(false);
      }
    };

    fetchEvents();
  }, []);

  // Countdown timer for featured event
  useEffect(() => {
    if (!featuredEvent) return;

    const timer = setInterval(() => {
      const now = new Date().getTime();
      const eventDateTime = new Date(featuredEvent.eventDate).getTime();
      const distance = eventDateTime - now;

      if (distance < 0) {
        setFeaturedEventTimeLeft({ days: '00', hours: '00', minutes: '00', seconds: '00' });
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      setFeaturedEventTimeLeft({
        days: days.toString().padStart(2, '0'),
        hours: hours.toString().padStart(2, '0'),
        minutes: minutes.toString().padStart(2, '0'),
        seconds: seconds.toString().padStart(2, '0'),
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [featuredEvent]);

  // General countdown timer
  useEffect(() => {
    const timer = setInterval(() => {
      const now = new Date().getTime();
      const distance = eventDate - now;

      if (distance < 0) {
        setTimeLeft({ days: '00', hours: '00', minutes: '00', seconds: '00' });
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      setTimeLeft({
        days: days.toString().padStart(2, '0'),
        hours: hours.toString().padStart(2, '0'),
        minutes: minutes.toString().padStart(2, '0'),
        seconds: seconds.toString().padStart(2, '0'),
      });
    }, 1000);

    const handleScroll = () => {
      setShowBackToTop(window.scrollY > 300);
      setShowFloatingButtons(window.scrollY > 500);
    };
    window.addEventListener('scroll', handleScroll);

    return () => {
      clearInterval(timer);
      window.removeEventListener('scroll', handleScroll);
    };
  }, [eventDate]);

  const handleBackToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const formatDate = (dateString) => {
    if (!dateString) return "TBA";
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', { 
        year: 'numeric', 
        month: 'long', 
        day: 'numeric' 
      });
    } catch {
      return dateString;
    }
  };

  const generateWhatsAppMessage = (formData) => {
    const message = `*ROYAL HERITAGE FIESTA - New Booking Enquiry*

*Contact Information:*
Name: ${formData.customerName || 'Not provided'}
Email: ${formData.email || 'Not provided'}
Phone: ${formData.phoneNumber || 'Not provided'}

*Event Information:*
Event Type: ${formData.eventType || 'Not provided'}
Attendees: ${formData.attendees || 'Not provided'}
Preferred Date: ${formData.preferredDate || 'Not provided'}

*Event Requirements:*
Requirements: ${formData.requirements || 'Not provided'}

---
*This enquiry was submitted from Royal Heritage Fiesta website.*`;

    return encodeURIComponent(message);
  };

  const handleBookingSubmit = async (e) => {
    e.preventDefault();
    setFormLoading(true);
    setFormSuccess('');
    setFormError('');

    const formData = new FormData(e.target);
    const data = {
      customerName: formData.get('customerName'),
      email: formData.get('email'),
      phoneNumber: formData.get('phoneNumber'),
      eventType: formData.get('eventType'),
      attendees: formData.get('attendees'),
      preferredDate: formData.get('preferredDate'),
      requirements: formData.get('requirements'),
      consent: formData.get('consent') === 'on',
    };

    if (!data.consent) {
      setFormError('Please agree to the data consent to proceed.');
      setFormLoading(false);
      setTimeout(() => setFormError(''), 3000);
      return;
    }

    if (!data.customerName || !data.email || !data.phoneNumber || !data.eventType) {
      setFormError('Please fill in all required fields marked with *');
      setFormLoading(false);
      setTimeout(() => setFormError(''), 3000);
      return;
    }

    try {
      const message = generateWhatsAppMessage(data);
      const phoneNumber = cmsContent.booking?.whatsapp_number || "919966252374";
      const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;
      window.open(whatsappUrl, '_blank');
      
      setFormSuccess('✓ Thank you! WhatsApp has been opened with your enquiry details.');
      e.target.reset();
      
    } catch (error) {
      console.error('Form submission error:', error);
      setFormError('Something went wrong. Please try again.');
    } finally {
      setFormLoading(false);
      setTimeout(() => {
        setFormSuccess('');
        setFormError('');
      }, 6000);
    }
  };

  const handleWhatsAppClick = () => {
    const phoneNumber = cmsContent.booking?.whatsapp_number || "919966252374";
    window.open(`https://wa.me/${phoneNumber}?text=Hi%20Royal%20Heritage%20Fiesta%20team,%20I%27m%20interested%20in%20your%20services.`, '_blank');
  };

  const navigateToEventDetails = (event) => {
    navigate('/eventCard', { 
      state: { 
        eventId: event.eventId,
        eventData: event 
      } 
    });
  };

  const navigateToStallBooking = (event, e) => {
    e.stopPropagation();
    navigate('/Booking_event', { 
      state: { 
        eventId: event.eventId,
        eventData: event 
      } 
    });
  };

  const navigateToTicketBooking = (event, e) => {
    e.stopPropagation();
    navigate('/BookingTicket', { 
      state: { 
        eventId: event.eventId,
        eventData: event 
      } 
    });
  };

  if (contentLoading) {
    return (
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        minHeight: '100vh', background: '#0f172a', flexDirection: 'column', gap: '1rem'
      }}>
        <div style={{
          width: 48, height: 48, border: '3px solid #334155',
          borderTop: '3px solid #f59e0b', borderRadius: '50%',
          animation: 'spin 0.8s linear infinite'
        }} />
        <p style={{ color: '#94a3b8', fontFamily: 'sans-serif' }}>Loading...</p>
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    );
  }

  return (
    <>
      <Navbar />

      <style>{`
        body { 
          background: #111; 
          font-family: 'Montserrat', sans-serif; 
          margin: 0; 
          color: #333; 
        }

        .main-container {
          background: #f5f5f5;
          margin: 0 auto;
          width: 100%;
          max-width: 100%;
          padding: 0px 20px;
          border-left: 29.5px solid #000 !important;
          border-right: 29.5px solid #000 !important;
          box-sizing: border-box;
        }

        .carousel-modern {
          position: relative;
          width: 100%;
          height: 55vh;
          min-height: 450px;
          max-height: 600px;
          overflow: hidden;
          border-radius: 16px;
          margin-bottom: 30px;
          cursor: pointer;
        }

        .carousel-slides-modern {
          position: relative;
          width: 100%;
          height: 100%;
        }

        .carousel-slide-modern {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          opacity: 0;
          transition: opacity 0.6s ease-in-out;
        }

        .carousel-slide-modern.active {
          opacity: 1;
        }

        .carousel-slide-modern img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          filter: brightness(65%);
        }

        .carousel-overlay {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          color: #fff;
          text-align: center;
          background: rgba(0,0,0,0.4);
          z-index: 2;
        }

        .carousel-overlay h2 {
          font-family: 'Cinzel', serif;
          font-size: 3rem;
          font-weight: 700;
          margin-bottom: 1rem;
          color: #fff;
        }

        .carousel-overlay p {
          font-size: 1.2rem;
          max-width: 70%;
          margin: 0 auto;
          color: #fff;
        }

        .section-title {
          text-align: center;
          margin: 40px 0 30px;
        }
        
        .section-title h2 {
          font-family: 'Cinzel', serif;
          font-size: 32px;
          font-weight: 700;
          color: #000;
          position: relative;
          display: inline-block;
          padding-bottom: 12px;
        }
        
        .section-title h2:after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 60px;
          height: 2px;
          background: #b8860b;
        }

        .section-header-with-link {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 30px;
          flex-wrap: wrap;
          gap: 15px;
        }

        .section-tag {
          color: #b8860b;
          font-size: 12px;
          letter-spacing: 2px;
          text-transform: uppercase;
          margin-bottom: 10px;
          display: inline-block;
        }

        .btn-custom {
          border: 1px solid #b8860b;
          background: transparent;
          color: #b8860b;
          padding: 10px 25px;
          border-radius: 30px;
          font-size: 13px;
          font-weight: 500;
          transition: 0.3s;
          text-decoration: none;
          display: inline-flex;
          align-items: center;
          gap: 8px;
        }

        .btn-custom:hover {
          background: #b8860b;
          color: #fff;
        }

        .featured-event-section {
          background: #f5f5f5;
          padding: 40px 0;
          margin: 20px 0;
        }

        .featured-event {
          background: #fff;
          border-radius: 15px;
          overflow: hidden;
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 0;
          box-shadow: 0 5px 20px rgba(0,0,0,0.05);
        }

        .featured-event-image {
          height: 450px;
          overflow: hidden;
        }

        .featured-event-image img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .featured-event-content {
          padding: 40px;
        }

        .featured-badge {
          background: #b8860b;
          color: #fff;
          padding: 5px 15px;
          border-radius: 20px;
          font-size: 11px;
          font-weight: 600;
          display: inline-block;
          margin-bottom: 20px;
        }

        .featured-event-content h3 {
          font-family: 'Cinzel', serif;
          font-size: 28px;
          font-weight: 700;
          margin-bottom: 20px;
          color: #000;
        }

        .featured-event-content p {
          color: #666;
          margin-bottom: 20px;
          line-height: 1.6;
        }

        .featured-event-details {
          display: flex;
          gap: 20px;
          margin-bottom: 20px;
          flex-wrap: wrap;
        }

        .featured-event-details .detail {
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 13px;
          color: #666;
        }

        .featured-event-timer {
          display: flex;
          align-items: center;
          gap: 15px;
          background: #f5f5f5;
          padding: 12px 20px;
          border-radius: 40px;
          margin: 20px 0;
          width: fit-content;
        }

        .featured-event-actions {
          display: flex;
          gap: 15px;
          flex-wrap: wrap;
        }

        .btn-stall, .btn-ticket {
          padding: 10px 25px;
          border-radius: 30px;
          font-size: 13px;
          font-weight: 500;
          cursor: pointer;
          transition: 0.3s;
          border: none;
          display: inline-flex;
          align-items: center;
          gap: 8px;
        }

        .btn-stall {
          background: transparent;
          color: #b8860b;
          border: 1px solid #b8860b;
        }

        .btn-stall:hover {
          background: #b8860b;
          color: #fff;
        }

        .btn-ticket {
          background: #b8860b;
          color: #fff;
          border: 1px solid #b8860b;
        }

        .btn-ticket:hover {
          background: transparent;
          color: #b8860b;
        }

        .events-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 25px;
          margin-top: 20px;
        }

        .event-card {
          border-radius: 15px;
          overflow: hidden;
          cursor: pointer;
          transition: 0.3s;
          background: #fff;
          height: 100%;
          display: flex;
          flex-direction: column;
          box-shadow: 0 3px 10px rgba(0,0,0,0.05);
        }

        .event-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 25px rgba(184,134,11,0.1);
        }

        .event-card-image {
          height: 200px;
          overflow: hidden;
        }

        .event-card-image img {
          height: 100%;
          width: 100%;
          object-fit: cover;
          transition: 0.5s;
        }

        .event-card-content {
          padding: 20px;
          flex-grow: 1;
        }

        .event-tag {
          color: #b8860b;
          font-size: 11px;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 1px;
          display: inline-block;
          margin-bottom: 10px;
        }

        .event-card-content h4 {
          font-family: 'Cinzel', serif;
          font-size: 18px;
          font-weight: 700;
          margin: 10px 0;
          color: #000;
        }

        .event-meta {
          display: flex;
          flex-direction: column;
          gap: 8px;
          margin: 15px 0;
        }

        .event-meta span {
          display: flex;
          align-items: center;
          gap: 8px;
          color: #666;
          font-size: 12px;
        }

        .event-timer {
          display: flex;
          align-items: center;
          gap: 8px;
          background: #f5f5f5;
          padding: 8px 12px;
          border-radius: 8px;
          margin: 15px 0;
          font-size: 12px;
        }

        .event-actions {
          display: flex;
          gap: 10px;
          margin-top: auto;
        }

        .btn-stall-small, .btn-ticket-small {
          flex: 1;
          padding: 8px;
          border-radius: 6px;
          font-size: 11px;
          font-weight: 500;
          cursor: pointer;
          transition: 0.3s;
          border: none;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 5px;
        }

        .btn-stall-small {
          background: transparent;
          color: #b8860b;
          border: 1px solid #b8860b;
        }

        .btn-stall-small:hover {
          background: #b8860b;
          color: #fff;
        }

        .btn-ticket-small {
          background: #b8860b;
          color: #fff;
          border: 1px solid #b8860b;
        }

        .btn-ticket-small:hover {
          background: transparent;
          color: #b8860b;
        }

        .services-section {
          padding: 50px 0;
        }

        .services-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 25px;
        }

        .service-card {
          background: #fff;
          border-radius: 12px;
          padding: 25px;
          border: 1px solid #eee;
          transition: 0.3s;
          height: 100%;
          text-align: center;
          cursor: pointer;
        }

        .service-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 25px rgba(184,134,11,0.1);
          border-color: #b8860b;
        }

        .service-icon {
          width: 70px;
          height: 70px;
          background: rgba(184,134,11,0.1);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 20px;
        }

        .service-icon i {
          font-size: 32px;
          color: #b8860b;
        }

        .service-card h4 {
          font-family: 'Cinzel', serif;
          font-size: 20px;
          font-weight: 700;
          margin-bottom: 12px;
          color: #000;
        }

        .service-card p {
          color: #666;
          font-size: 13px;
          line-height: 1.5;
        }

        .booking-section {
          background: #fff;
          padding: 50px 0;
          margin: 20px 0;
          border-radius: 15px;
        }

        .booking-card {
          max-width: 900px;
          margin: 0 auto;
          padding: 30px;
        }

        .booking-form {
          display: flex;
          flex-direction: column;
          gap: 20px;
        }

        .form-row {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 20px;
        }

        .form-group {
          display: flex;
          flex-direction: column;
          gap: 8px;
        }

        .form-group.full-width {
          grid-column: span 2;
        }

        .form-label {
          font-weight: 500;
          color: #333;
          font-size: 13px;
        }

        .form-control, .form-select {
          padding: 12px 15px;
          border: 1px solid #ddd;
          border-radius: 8px;
          font-size: 13px;
          transition: 0.3s;
        }

        .form-control:focus, .form-select:focus {
          border-color: #b8860b;
          outline: none;
        }

        .alert-success {
          background: #d4edda;
          color: #155724;
          padding: 12px;
          border-radius: 8px;
          margin-bottom: 20px;
          font-size: 13px;
        }

        .alert-danger {
          background: #f8d7da;
          color: #721c24;
          padding: 12px;
          border-radius: 8px;
          margin-bottom: 20px;
          font-size: 13px;
        }

        .btn-submit {
          background: #b8860b;
          color: #fff;
          border: none;
          padding: 14px 30px;
          border-radius: 40px;
          font-weight: 600;
          font-size: 14px;
          cursor: pointer;
          transition: 0.3s;
          display: inline-flex;
          align-items: center;
          gap: 10px;
          margin-top: 10px;
        }

        .btn-submit:hover {
          background: #9b6e09;
          transform: translateY(-2px);
        }

        .checkbox-wrapper {
          display: flex;
          align-items: flex-start;
          gap: 12px;
          margin: 10px 0;
        }

        .checkbox-wrapper input[type="checkbox"] {
          width: 18px;
          height: 18px;
          margin: 2px 0 0 0;
          cursor: pointer;
          accent-color: #b8860b;
          flex-shrink: 0;
        }

        .checkbox-wrapper label {
          font-size: 13px;
          color: #333;
          cursor: pointer;
          line-height: 1.4;
          margin: 0;
        }

        .about {
          background: #000;
          color: #fff;
          padding: 40px;
          text-align: center;
          margin-top: 40px;
          border-radius: 16px;
        }

        .about h3 {
          font-family: 'Cinzel', serif;
          font-size: 24px;
          margin-bottom: 15px;
        }

        .about p {
          font-size: 14px;
          color: #aaa;
        }

        .testimonials-section {
          padding: 50px 0;
        }

        .testimonials-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 25px;
        }

        .testimonial-card {
          background: #fff;
          border-radius: 12px;
          padding: 25px;
          border: 1px solid #eee;
          transition: 0.3s;
          height: 100%;
        }

        .testimonial-card:hover {
          transform: translateY(-3px);
          box-shadow: 0 5px 15px rgba(184,134,11,0.1);
        }

        .testimonial-quote {
          color: #b8860b;
          font-size: 32px;
          margin-bottom: 15px;
          opacity: 0.3;
        }

        .testimonial-text {
          font-size: 13px;
          color: #666;
          margin-bottom: 20px;
          line-height: 1.6;
        }

        .testimonial-author {
          display: flex;
          align-items: center;
          gap: 12px;
        }

        .author-image {
          width: 45px;
          height: 45px;
          border-radius: 50%;
          object-fit: cover;
        }

        .author-info h5 {
          font-size: 14px;
          font-weight: 700;
          color: #000;
          margin-bottom: 3px;
        }

        .author-info span {
          font-size: 11px;
          color: #666;
        }

        .locations-section {
          background: #f5f5f5;
          padding: 50px 0;
          margin: 20px 0;
          border-radius: 16px;
        }

        .locations-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 30px;
        }

        .location-card {
          background: #fff;
          border-radius: 12px;
          padding: 30px;
          border: 1px solid #eee;
        }

        .location-card h4 {
          font-family: 'Cinzel', serif;
          font-size: 20px;
          font-weight: 700;
          margin-bottom: 20px;
          color: #000;
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .location-card p {
          color: #666;
          font-size: 13px;
          margin-bottom: 10px;
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .location-badge {
          display: inline-block;
          background: rgba(184,134,11,0.1);
          color: #b8860b;
          padding: 5px 12px;
          border-radius: 20px;
          font-size: 11px;
          font-weight: 600;
          margin-top: 15px;
        }

        .map-container {
          border-radius: 12px;
          overflow: hidden;
          box-shadow: 0 5px 15px rgba(0,0,0,0.1);
          height: 100%;
          min-height: 350px;
        }

        .map-container iframe {
          width: 100%;
          height: 100%;
          min-height: 350px;
        }

        .cta-section {
          padding: 60px 0;
          background: #000;
          margin: 20px 0;
          border-radius: 16px;
        }

        .cta-content {
          text-align: center;
          max-width: 700px;
          margin: 0 auto;
        }

        .cta-content h2 {
          font-family: 'Cinzel', serif;
          font-size: 32px;
          font-weight: 700;
          margin-bottom: 15px;
          color: #fff;
        }

        .cta-content p {
          font-size: 14px;
          color: #aaa;
          margin-bottom: 25px;
        }

        .cta-buttons {
          display: flex;
          gap: 15px;
          justify-content: center;
          flex-wrap: wrap;
        }

        .cta-buttons .btn-custom {
          border-color: #fff;
          color: #fff;
        }

        .cta-buttons .btn-custom:hover {
          background: #fff;
          color: #000;
        }

        .footer {
          background: #000;
          color: #aaa;
          padding: 30px;
          text-align: center;
          margin-top: 20px;
          border-radius: 12px;
        }

        .footer a {
          color: #fff;
          margin: 0 12px;
          text-decoration: none;
          font-size: 12px;
        }

        .footer a:hover {
          color: #b8860b;
        }

        .floating-buttons {
          position: fixed;
          bottom: 20px;
          right: 20px;
          display: flex;
          flex-direction: column;
          gap: 10px;
          z-index: 1000;
          opacity: 0;
          visibility: hidden;
          transform: translateY(20px);
          transition: 0.3s;
        }

        .floating-buttons.show {
          opacity: 1;
          visibility: visible;
          transform: translateY(0);
        }

        .floating-btn {
          width: 45px;
          height: 45px;
          border-radius: 50%;
          border: none;
          cursor: pointer;
          transition: 0.3s;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 20px;
          color: #fff;
          box-shadow: 0 2px 10px rgba(0,0,0,0.2);
        }

        .floating-btn.whatsapp {
          background: #25d366;
        }

        .floating-btn.top {
          background: #b8860b;
        }

        .floating-btn:hover {
          transform: scale(1.1);
        }

        .back-to-top {
          position: fixed;
          bottom: 20px;
          right: 20px;
          width: 45px;
          height: 45px;
          background: #b8860b;
          color: #fff;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          opacity: 0;
          visibility: hidden;
          transition: 0.2s;
          z-index: 99;
        }

        .back-to-top.show {
          opacity: 1;
          visibility: visible;
        }

        .floating-image-carousel {
          position: fixed;
          top: 100px;
          right: 20px;
          z-index: 1000;
          width: 100%;
          max-width: 280px;
          border-radius: 12px;
          overflow: hidden;
          box-shadow: 0 10px 30px rgba(0,0,0,0.2);
          background: #fff;
        }

        .floating-carousel-container {
          position: relative;
          width: 100%;
        }

        .floating-carousel-slide {
          position: relative;
          width: 100%;
        }

        .floating-carousel-slide img {
          width: 100%;
          height: auto;
          display: block;
          cursor: pointer;
        }

        .floating-close-btn {
          position: absolute;
          top: 8px;
          left: 8px;
          width: 30px;
          height: 30px;
          background: rgba(0,0,0,0.6);
          color: white;
          border-radius: 50%;
          border: none;
          cursor: pointer;
          z-index: 10;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 18px;
          transition: 0.3s;
        }

        .floating-close-btn:hover {
          background: rgba(0,0,0,0.8);
          transform: scale(1.05);
        }

        .floating-carousel-dots {
          position: absolute;
          bottom: 10px;
          left: 50%;
          transform: translateX(-50%);
          display: flex;
          gap: 8px;
          z-index: 10;
        }

        .floating-dot {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: rgba(255,255,255,0.5);
          cursor: pointer;
          transition: 0.3s;
        }

        .floating-dot.active {
          background: #b8860b;
          width: 20px;
          border-radius: 4px;
        }

        .floating-dot:hover {
          background: #b8860b;
        }

        .floating-nav-btn {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          width: 30px;
          height: 30px;
          background: rgba(0,0,0,0.5);
          color: white;
          border: none;
          border-radius: 50%;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 16px;
          transition: 0.3s;
          z-index: 10;
        }

        .floating-nav-btn:hover {
          background: rgba(0,0,0,0.8);
        }

        .floating-nav-prev {
          left: 5px;
        }

        .floating-nav-next {
          right: 5px;
        }

        @media (max-width: 992px) {
          .events-grid, .services-grid, .testimonials-grid {
            grid-template-columns: repeat(2, 1fr);
          }
          .featured-event {
            grid-template-columns: 1fr;
          }
          .locations-grid {
            grid-template-columns: 1fr;
          }
          .form-row {
            grid-template-columns: 1fr;
          }
          .form-group.full-width {
            grid-column: span 1;
          }
          .carousel-overlay h2 {
            font-size: 2rem;
          }
          .floating-image-carousel {
            max-width: 220px;
            top: 80px;
          }
        }

        @media (max-width: 768px) {
          .main-container {
            padding: 12px;
            border-left: 17.5px solid #000 !important;
            border-right: 17.5px solid #000 !important;
          }
          .events-grid, .services-grid, .testimonials-grid {
            grid-template-columns: 1fr;
          }
          .section-title h2 {
            font-size: 24px;
          }
          .carousel-overlay h2 {
            font-size: 1.5rem;
          }
          .carousel-overlay p {
            font-size: 0.9rem;
          }
          .floating-image-carousel {
            max-width: 180px;
            top: 70px;
            right: 10px;
          }
          .floating-nav-btn {
            width: 24px;
            height: 24px;
            font-size: 12px;
          }
          .floating-close-btn {
            width: 24px;
            height: 24px;
            font-size: 14px;
            top: 5px;
            left: 5px;
          }
        }
      `}</style>

      {/* MAIN CONTAINER */}
      <div className="main-container">
        {/* CAROUSEL */}
        <div className="carousel-modern" onClick={() => handleCarouselClick(carouselImages[currentSlide]?.link || '#')}>
          <div className="carousel-slides-modern">
            {carouselImages.map((slide, index) => (
              <div key={index} className={`carousel-slide-modern ${currentSlide === index ? 'active' : ''}`}>
                <img src={slide.url} alt={slide.title} />
                <div className="carousel-overlay">
                  <h2>{slide.title}</h2>
                  <p>{slide.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* FLOATING IMAGE CAROUSEL */}
        {showFloatingImage && floatingImages.length > 0 && (
          <div className="floating-image-carousel">
            <div className="floating-carousel-container">
              <button className="floating-close-btn" onClick={() => setShowFloatingImage(false)}>×</button>
              <button className="floating-nav-btn floating-nav-prev" onClick={() => setCurrentFloatingSlide((prev) => (prev - 1 + floatingImages.length) % floatingImages.length)}>‹</button>
              <button className="floating-nav-btn floating-nav-next" onClick={() => setCurrentFloatingSlide((prev) => (prev + 1) % floatingImages.length)}>›</button>
              <div className="floating-carousel-slide">
                <img src={floatingImages[currentFloatingSlide].src} alt={floatingImages[currentFloatingSlide].alt} onClick={() => window.open(floatingImages[currentFloatingSlide].src, '_blank')} />
              </div>
              <div className="floating-carousel-dots">
                {floatingImages.map((_, index) => (
                  <div key={index} className={`floating-dot ${currentFloatingSlide === index ? 'active' : ''}`} onClick={() => setCurrentFloatingSlide(index)} />
                ))}
              </div>
            </div>
          </div>
        )}

        {/* FEATURED EVENT SECTION */}
        {featuredEvent && (
          <div className="featured-event-section">
            <div className="featured-event">
              <div className="featured-event-image">
                <img src={featuredEvent.img} alt={featuredEvent.eventName} />
              </div>
              <div className="featured-event-content">
                <span className="featured-badge">{cmsContent.featuredEvent?.badge || "FEATURED EVENT"}</span>
                <h3>{featuredEvent.eventName}</h3>
                <p>{featuredEvent.highlights || "Join us for an unforgettable royal experience."}</p>
                <div className="featured-event-details">
                  <span className="detail"><i className="bi bi-calendar-event"></i> {formatDate(featuredEvent.eventDate)}</span>
                  <span className="detail"><i className="bi bi-geo-alt"></i> {featuredEvent.place || "Hyderabad"}</span>
                </div>
                <div className="featured-event-timer">
                  <i className="bi bi-clock"></i>
                  <span>Event starts in: {featuredEventTimeLeft.days}d {featuredEventTimeLeft.hours}h {featuredEventTimeLeft.minutes}m {featuredEventTimeLeft.seconds}s</span>
                </div>
                <div className="featured-event-actions">
                  <button className="btn-stall" onClick={(e) => navigateToStallBooking(featuredEvent, e)}><i className="bi bi-shop"></i> {cmsContent.featuredEvent?.button1 || "Book a Stall"}</button>
                  <button className="btn-ticket" onClick={(e) => navigateToTicketBooking(featuredEvent, e)}><i className="bi bi-ticket"></i> {cmsContent.featuredEvent?.button2 || "Get Tickets"}</button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* UPCOMING EVENTS SECTION */}
        <div className="section-header-with-link">
          <div>
            <span className="section-tag">{cmsContent.upcomingEvents?.subtitle || "✦ UPCOMING EVENTS"}</span>
            <h2 className="section-title" style={{ margin: 0, color: '#000' }}>{cmsContent.upcomingEvents?.title || "Featured Events"}</h2>
          </div>
          <Link to="/eventcalander_2" className="btn-custom">{cmsContent.upcomingEvents?.viewAllText || "View all"} <i className="bi bi-arrow-right"></i></Link>
        </div>

        {loading ? (
          <div className="text-center py-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="mt-3">Loading amazing events...</p>
          </div>
        ) : upcomingEvents.length > 0 ? (
          <div className="events-grid">
            {upcomingEvents.map((event) => {
              const eventDateTime = new Date(event.eventDate).getTime();
              const now = new Date().getTime();
              const distance = eventDateTime - now;
              const days = Math.floor(distance / (1000 * 60 * 60 * 24));
              const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
              
              return (
                <div className="event-card" key={event.eventId} onClick={() => navigateToEventDetails(event)}>
                  <div className="event-card-image">
                    <img src={event.img} alt={event.eventName} />
                  </div>
                  <div className="event-card-content">
                    <span className="event-tag">{event.eventType || 'EVENT'}</span>
                    <h4>{event.eventName}</h4>
                    <div className="event-meta">
                      <span><i className="bi bi-calendar3"></i> {formatDate(event.eventDate)}</span>
                      <span><i className="bi bi-geo-alt"></i> {event.place || "Hyderabad"}</span>
                    </div>
                    <div className="event-timer">
                      <i className="bi bi-clock-history"></i>
                      <span>Starts in: {days}d {hours}h</span>
                    </div>
                    <div className="event-actions" onClick={(e) => e.stopPropagation()}>
                      <button className="btn-stall-small" onClick={(e) => navigateToStallBooking(event, e)}><i className="bi bi-shop"></i> Stall</button>
                      <button className="btn-ticket-small" onClick={(e) => navigateToTicketBooking(event, e)}><i className="bi bi-ticket"></i> Tickets</button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <div className="text-center py-5">
            <p>No upcoming events found.</p>
            {apiError && <p className="text-danger">{apiError}</p>}
          </div>
        )}

        {/* SERVICES SECTION */}
        <div className="services-section">
          <div className="section-title">
            <h2>{cmsContent.services?.title || "Our Signature Experiences"}</h2>
            <p>{cmsContent.services?.subtitle || "Discover the essence of royal celebrations"}</p>
          </div>
          <div className="services-grid">
            <div className="service-card" onClick={() => navigate(cmsContent.services?.service1_link || "/RoyalHeritageFiesta")}>
              <div className="service-icon">
                <i className="bi bi-globe2"></i>
              </div>
              <h4>{cmsContent.services?.service1_title || "Royal Heritage Fiesta"}</h4>
              <p>{cmsContent.services?.service1_desc || "Curated heritage experiences celebrating tradition and grandeur."}</p>
            </div>
            <div className="service-card" onClick={() => navigate(cmsContent.services?.service2_link || "/RoyalDinners")}>
              <div className="service-icon">
                <i className="bi bi-cup-straw"></i>
              </div>
              <h4>{cmsContent.services?.service2_title || "Royal Dinners"}</h4>
              <p>{cmsContent.services?.service2_desc || "Exquisite fine dining experiences with royal ambiance and culinary mastery."}</p>
            </div>
            <div className="service-card" onClick={() => navigate(cmsContent.services?.service3_link || "/MusicAndConcerts")}>
              <div className="service-icon">
                <i className="bi bi-music-note-beamed"></i>
              </div>
              <h4>{cmsContent.services?.service3_title || "Music & Concerts"}</h4>
              <p>{cmsContent.services?.service3_desc || "World-class performances and unforgettable musical experiences."}</p>
            </div>
          </div>
        </div>

        {/* BOOKING FORM SECTION */}
        <div className="booking-section" id="booking">
          <div className="booking-card">
            <div className="section-title" style={{ marginTop: 0 }}>
              <h2>{cmsContent.booking?.title || "Plan Your Royal Experience"}</h2>
              <p>{cmsContent.booking?.subtitle || "Share your details and we'll get back to you via WhatsApp"}</p>
            </div>
            
            {formSuccess && <div className="alert-success">{formSuccess}</div>}
            {formError && <div className="alert-danger">{formError}</div>}
            
            <form className="booking-form" onSubmit={handleBookingSubmit}>
              <div className="form-row">
                <div className="form-group">
                  <label className="form-label">Full Name *</label>
                  <input type="text" className="form-control" name="customerName" placeholder="Enter your full name" required />
                </div>
                <div className="form-group">
                  <label className="form-label">Email Address *</label>
                  <input type="email" className="form-control" name="email" placeholder="you@example.com" required />
                </div>
              </div>
              
              <div className="form-row">
                <div className="form-group">
                  <label className="form-label">Phone Number *</label>
                  <input type="tel" className="form-control" name="phoneNumber" placeholder="+91 98765 43210" required />
                </div>
                <div className="form-group">
                  <label className="form-label">Event Type *</label>
                  <select className="form-select" name="eventType" required defaultValue="">
                    <option value="" disabled>Select event type</option>
                    <option value="Royal Heritage Fiesta">Royal Heritage Fiesta</option>
                    <option value="Royal Dinners">Royal Dinners</option>
                    <option value="Music & Concerts">Music & Concerts</option>
                  </select>
                </div>
              </div>
              
              <div className="form-row">
                <div className="form-group">
                  <label className="form-label">Expected Guests</label>
                  <input type="number" className="form-control" name="attendees" placeholder="Number of guests" />
                </div>
                <div className="form-group">
                  <label className="form-label">Preferred Date</label>
                  <input type="date" className="form-control" name="preferredDate" />
                </div>
              </div>
              
              <div className="form-group full-width">
                <label className="form-label">Special Requirements</label>
                <textarea className="form-control" name="requirements" rows="3" placeholder="Tell us about your vision, dietary restrictions, or any special requests..."></textarea>
              </div>
              
              <div className="form-group full-width">
                <div className="checkbox-wrapper">
                  <input type="checkbox" name="consent" id="consent" required />
                  <label htmlFor="consent">I agree to receive communications and consent to the processing of my data.</label>
                </div>
              </div>
              
              <div className="form-submit">
                <button type="submit" className="btn-submit" disabled={formLoading}>
                  <i className="bi bi-whatsapp"></i> {formLoading ? 'Sending...' : (cmsContent.booking?.button_text || 'Send via WhatsApp')}
                </button>
              </div>
            </form>
          </div>
        </div>

        {/* ABOUT SECTION */}
        <div className="about" id="about">
          <h3>{cmsContent.about?.title || "About Royal Heritage Fiesta"}</h3>
          <p>{cmsContent.about?.description || "Royal Heritage Fiesta is dedicated to creating unforgettable experiences that blend tradition with modern elegance. From majestic royal dinners to spectacular concerts, we bring your vision to life with impeccable attention to detail and timeless sophistication."}</p>
        </div>

        {/* TESTIMONIALS SECTION - WITH DYNAMIC IMAGES */}
        <div className="testimonials-section">
          <div className="section-title">
            <h2>{cmsContent.testimonials?.title || "What Our Guests Say"}</h2>
            <p>{cmsContent.testimonials?.subtitle || "Experiences that speak for themselves"}</p>
          </div>
          <div className="testimonials-grid">
            <div className="testimonial-card">
              <i className="bi bi-quote testimonial-quote"></i>
              <p className="testimonial-text">"{cmsContent.testimonials?.testimonial1_text || "The Royal Heritage Fiesta was absolutely magnificent! Every detail was perfect."}"</p>
              <div className="testimonial-author">
                <img src={cmsImages.testimonial_1_avatar || Testimonial} className="author-image" alt={cmsContent.testimonials?.testimonial1_name || "Vikram Singh"} />
                <div className="author-info">
                  <h5>{cmsContent.testimonials?.testimonial1_name || "Vikram Singh"}</h5>
                  <span>{cmsContent.testimonials?.testimonial1_title || "Event Attendee"}</span>
                </div>
              </div>
            </div>
            <div className="testimonial-card">
              <i className="bi bi-quote testimonial-quote"></i>
              <p className="testimonial-text">"{cmsContent.testimonials?.testimonial2_text || "The Royal Dinners experience was beyond imagination. Truly world-class hospitality."}"</p>
              <div className="testimonial-author">
                <img src={cmsImages.testimonial_2_avatar || Testimonial} className="author-image" alt={cmsContent.testimonials?.testimonial2_name || "Meera Kapoor"} />
                <div className="author-info">
                  <h5>{cmsContent.testimonials?.testimonial2_name || "Meera Kapoor"}</h5>
                  <span>{cmsContent.testimonials?.testimonial2_title || "Dinner Guest"}</span>
                </div>
              </div>
            </div>
            <div className="testimonial-card">
              <i className="bi bi-quote testimonial-quote"></i>
              <p className="testimonial-text">"{cmsContent.testimonials?.testimonial3_text || "The concert was spectacular! Perfect acoustics and unforgettable performances."}"</p>
              <div className="testimonial-author">
                <img src={cmsImages.testimonial_3_avatar || Testimonial} className="author-image" alt={cmsContent.testimonials?.testimonial3_name || "Arjun Nair"} />
                <div className="author-info">
                  <h5>{cmsContent.testimonials?.testimonial3_name || "Arjun Nair"}</h5>
                  <span>{cmsContent.testimonials?.testimonial3_title || "Music Lover"}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* LOCATIONS SECTION */}
        <div className="locations-section">
          <div className="section-title">
            <h2>{cmsContent.location?.title || "Our Venues"}</h2>
            <p>{cmsContent.location?.subtitle || "Experience royalty at our premier locations"}</p>
          </div>
          <div className="locations-grid">
            <div className="location-card">
              <h4><i className="bi bi-building"></i> {cmsContent.location?.hq_name || "Hyderabad (HQ)"}</h4>
              <p><i className="bi bi-geo-alt"></i> {cmsContent.location?.hq_address || "VIP Hills, Silicon Valley, Madhapur"}</p>
              <p>{cmsContent.location?.hq_city || "Hyderabad - 500081, Telangana"}</p>
              <p><i className="bi bi-telephone"></i> {cmsContent.location?.hq_phone || "+91 99662 52374"}</p>
              <p><i className="bi bi-envelope"></i> {cmsContent.location?.hq_email || "royaleheritagefiesta@gmail.com"}</p>
              <span className="location-badge">Headquarters</span>
            </div>
            <div className="map-container">
              <iframe src={cmsContent.location?.map_embed || "https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d7612.584996745508!2d78.38633559192071!3d17.445708893577407!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v1774850334297!5m2!1sen!2sin"} width="100%" height="100%" style={{ border: 0 }} allowFullScreen loading="lazy" title="Hyderabad Map"></iframe>
            </div>
          </div>
        </div>

        {/* CTA SECTION */}
        <div className="cta-section">
          <div className="cta-content">
            <h2>{cmsContent.cta?.title || "Ready To Experience Royalty?"}</h2>
            <p>{cmsContent.cta?.subtitle || "Book your seat at our next grand celebration"}</p>
            <div className="cta-buttons">
              <a href={`tel:${cmsContent.cta?.phone1 || "+919396536350"}`} className="btn-custom"><i className="bi bi-telephone-fill"></i> {cmsContent.cta?.button1_text || "Talk to us"}</a>
              <a href={`tel:${cmsContent.cta?.phone2 || "+919966252374"}`} className="btn-custom"><i className="bi bi-phone"></i> {cmsContent.cta?.button2_text || "Call +91 99662 52374"}</a>
            </div>
          </div>
        </div>
      </div>

      <Footer />

      {/* Floating Buttons */}
      <div className={`floating-buttons ${showFloatingButtons ? 'show' : ''}`}>
        <button className="floating-btn whatsapp" onClick={handleWhatsAppClick}><i className="bi bi-whatsapp"></i></button>
        <button className="floating-btn top" onClick={handleBackToTop}><i className="bi bi-arrow-up"></i></button>
      </div>
      <div className={`back-to-top ${showBackToTop ? 'show' : ''}`} onClick={handleBackToTop}><i className="bi bi-arrow-up"></i></div>
    </>
  );
};

export default Home;